export default {"src":"/_next/static/media/area_visits_3.4bf0347f.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};